module.exports = __webpack_public_path__ + "img/l2.6e28a303.png";